import { render, staticRenderFns } from "./EditLogicDialog.vue?vue&type=template&id=bebbdc88&scoped=true"
import script from "./EditLogicDialog.vue?vue&type=script&lang=ts"
export * from "./EditLogicDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebbdc88",
  null
  
)

export default component.exports